module.exports = __webpack_public_path__ + "img/logo.64c7579d.svg";